<template>
  <div>
    <Movementmenu />

    <v-container fluid class="pa-6" tag="section">
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between mb-2">
            <div>
              <h2 class="text-h4 font-weight-bold primary--text">
                <v-icon large color="primary" class="mr-2"
                  >mdi-swap-horizontal-bold</v-icon
                >
                ประมวลผลการย้าย: สับเปลี่ยนตำแหน่ง (Normal Switch)
              </h2>
              <div class="subtitle-1 grey--text text--darken-1 mt-1">
                ระบบจับคู่และตรวจสอบคุณสมบัติการสับเปลี่ยนบุคลากร (Person A ⇄
                Person B)
              </div>
            </div>
            <v-btn
              color="indigo"
              dark
              large
              rounded
              elevation="3"
              @click="Switch_personnelAll()"
              :loading="loading"
            >
              <v-icon left>mdi-refresh</v-icon> ประมวลผลใหม่
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #1976D2"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รายการทั้งหมด</div>
                <div class="text-h4 font-weight-bold">{{ stats.total }}</div>
              </div>
              <v-avatar color="blue lighten-5" size="60">
                <v-icon color="blue" x-large>mdi-format-list-bulleted</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #4CAF50"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">จับคู่สมบูรณ์ (ปกติ)</div>
                <div class="text-h4 font-weight-bold success--text">
                  {{ stats.completed }}
                </div>
              </div>
              <v-avatar color="green lighten-5" size="60">
                <v-icon color="success" x-large
                  >mdi-check-circle-outline</v-icon
                >
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #FB8C00"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">
                  รายการรับย้าย (Demand)
                </div>
                <div class="text-h4 font-weight-bold warning--text">
                  {{ stats.demand }}
                </div>
              </div>
              <v-avatar color="orange lighten-5" size="60">
                <v-icon color="warning" x-large>mdi-handshake</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #F44336"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">
                  รอดำเนินการ / ผิดพลาด
                </div>
                <div class="text-h4 font-weight-bold error--text">
                  {{ stats.issue }}
                </div>
              </div>
              <v-avatar color="red lighten-5" size="60">
                <v-icon color="error" x-large>mdi-alert-circle-outline</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card elevation="2" class="rounded-lg">
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="ค้นหาชื่อ, วิทยาลัย, หรือรหัส..."
            single-line
            hide-details
            outlined
            dense
            rounded
            class="mr-4"
            style="max-width: 400px;"
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn color="success" outlined class="mr-2" @click="exportToExcel">
            <v-icon left>mdi-file-excel</v-icon> Export Excel
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>

        <v-data-table
          v-model="select_item"
          :headers="headers"
          :items="conditions_transfers"
          :search="search"
          :loading="loading"
          :items-per-page="10"
          class="elevation-0"
        >
          <template v-slot:header.id_card_a="{ header }">
            <div class="text-center primary--text pl-2 border-left">
              <v-icon small color="primary">mdi-account</v-icon> ฝั่งผู้ย้าย (A)
            </div>
          </template>
          <template v-slot:header.switch_position="{ header }">
            <div class="text-center info--text pl-2">
              <v-icon small color="info">mdi-account-switch</v-icon> ฝั่งคู่สลับ
              (B)
            </div>
          </template>

          <template v-slot:item.select_item="{ item }">
            <v-checkbox
              v-model="selected"
              :value="item.id_card_a"
              color="primary"
            ></v-checkbox>
          </template>

          <template v-slot:item.person_a_details="{ item }">
            <div class="d-flex flex-column py-2">
              <span class="font-weight-bold text-subtitle-2"
                >{{ item.title_s_a }}{{ item.frist_name_a }}
                {{ item.last_name_a }}</span
              >
              <span class="caption grey--text"
                ><v-icon x-small>mdi-card-account-details</v-icon>
                {{ item.id_card_a }}</span
              >
              <v-chip
                x-small
                color="primary"
                outlined
                class="mt-1"
                style="width: fit-content;"
              >
                {{ item.college_name_a }}
              </v-chip>
            </div>
          </template>

          <template v-slot:item.status_process="{ item }">
            <div class="d-flex justify-center align-center">
              <v-icon color="grey lighten-1">mdi-arrow-right-bold</v-icon>
            </div>
          </template>

          <template v-slot:item.person_b_details="{ item }">
            <div class="d-flex flex-column py-2 text-right">
              <span class="font-weight-bold text-subtitle-2"
                >{{ item.title_s_b }}{{ item.frist_name_b }}
                {{ item.last_name_b }}</span
              >
              <span class="caption grey--text"
                >{{ item.switch_position }}
                <v-icon x-small>mdi-card-account-details</v-icon></span
              >
              <div class="d-flex justify-end">
                <v-chip x-small color="info" outlined class="mt-1">
                  {{ item.college_name_b }}
                </v-chip>
              </div>
            </div>
          </template>

          <template v-slot:item.college_code_susss="{ item }">
            <div class="text-center">
              <v-chip
                v-if="item.college_code_susss >= 1"
                color="success"
                text-color="white"
                small
              >
                <v-icon left small>mdi-check</v-icon> สำเร็จ
              </v-chip>
              <v-chip v-else color="grey" text-color="white" small>
                รออนุมัติ
              </v-chip>
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-center">
              <v-tooltip bottom v-if="item.college_code_susss >= 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="deletePosition(item.id_ref)"
                  >
                    <v-icon>mdi-delete-circle</v-icon>
                  </v-btn>
                </template>
                <span>ยกเลิกรายการนี้</span>
              </v-tooltip>

              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="green"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="select_idPosition(item.id_ref)"
                  >
                    <v-icon>mdi-content-save-edit</v-icon>
                  </v-btn>
                </template>
                <span>บันทึก/จับคู่ตำแหน่ง</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:no-data>
            <div class="text-center pa-4">
              <v-icon large color="grey lighten-2">mdi-database-off</v-icon>
              <div class="grey--text mt-2">ไม่พบข้อมูลการสับเปลี่ยน</div>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="canceldialog" persistent max-width="900px">
        <v-card class="rounded-xl overflow-hidden">
          <v-toolbar color="red lighten-1" dark flat>
            <v-icon class="mr-2">mdi-alert-circle</v-icon> ยืนยันการยกเลิกรายการ
            <v-spacer></v-spacer>
            <v-btn icon @click="canceldialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-alert type="warning" text dense border="left">
              กรุณาตรวจสอบข้อมูลก่อนทำการยกเลิก การกระทำนี้ไม่สามารถเรียกคืนได้
            </v-alert>
            <v-row>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-4 fill-height">
                  <div class="text-overline primary--text">
                    ข้อมูลฝั่ง A (ต้นทาง)
                  </div>
                  <v-divider class="mb-3"></v-divider>
                  <div class="font-weight-bold text-h6">
                    {{ transference_personnels.title_s
                    }}{{ transference_personnels.frist_name }}
                    {{ transference_personnels.last_name }}
                  </div>
                  <div class="text-body-2 grey--text mb-2">
                    ID: {{ transference_personnels.id_card }}
                  </div>
                  <div class="text-body-2">
                    <v-icon small>mdi-school</v-icon>
                    {{ transference_personnels.college_name }}
                  </div>
                  <div class="text-body-2">
                    <v-icon small>mdi-identifier</v-icon> เลขที่ตำแหน่ง:
                    {{ transference_personnels.id_position }}
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-4 fill-height">
                  <div class="text-overline info--text">
                    ข้อมูลฝั่ง B (คู่สลับ)
                  </div>
                  <v-divider class="mb-3"></v-divider>
                  <div class="font-weight-bold text-h6">
                    {{ personnel_temporarys.title_s
                    }}{{ personnel_temporarys.frist_name }}
                    {{ personnel_temporarys.last_name }}
                  </div>
                  <div class="text-body-2 grey--text mb-2">
                    ID: {{ personnel_temporarys.id_card }}
                  </div>
                  <div class="text-body-2">
                    <v-icon small>mdi-school</v-icon>
                    {{ personnel_temporarys.college_name }}
                  </div>
                  <div class="text-body-2">
                    <v-icon small>mdi-identifier</v-icon> เลขที่ตำแหน่ง:
                    {{ personnel_temporarys.id_position }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="grey lighten-5 pa-4">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="canceldialog = false"
              >ปิดหน้าต่าง</v-btn
            >
            <v-btn color="red" dark elevation="2" @click="cancelSubmit">
              <v-icon left>mdi-delete</v-icon> ยืนยันการยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="positiondialog" persistent max-width="900px">
        <v-card class="rounded-xl overflow-hidden">
          <v-toolbar color="success" dark flat>
            <v-icon class="mr-2">mdi-content-save-move</v-icon>
            บันทึกการสลับตำแหน่ง
            <v-spacer></v-spacer>
            <v-btn icon @click="positiondialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-form ref="updatepositionform" lazy-validation>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card elevation="0" color="green lighten-5" class="pa-4">
                    <div class="d-flex align-center mb-2">
                      <v-avatar color="green" size="30" class="mr-2"
                        ><span class="white--text font-weight-bold"
                          >A</span
                        ></v-avatar
                      >
                      <span class="font-weight-bold text-h6">ผู้ย้าย</span>
                    </div>
                    <div class="pl-10">
                      <div class="text-h6">
                        {{ transference_personnels.title_s
                        }}{{ transference_personnels.frist_name }}
                        {{ transference_personnels.last_name }}
                      </div>
                      <div class="caption grey--text mb-2">
                        จาก: {{ transference_personnels.college_name }}
                      </div>

                      <v-select
                        v-model="transference_personnels.id_branch"
                        :items="personnel_educations"
                        item-text="name_branch"
                        item-value="id_branch"
                        label="สาขาวิชาที่ลงตำแหน่งใหม่"
                        outlined
                        dense
                        background-color="white"
                        :rules="[v => !!v || 'กรุณาเลือกสาขา']"
                        prepend-inner-icon="mdi-book-open-variant"
                      ></v-select>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card elevation="0" color="blue lighten-5" class="pa-4">
                    <div class="d-flex align-center mb-2">
                      <v-avatar color="blue" size="30" class="mr-2"
                        ><span class="white--text font-weight-bold"
                          >B</span
                        ></v-avatar
                      >
                      <span class="font-weight-bold text-h6">คู่สลับ</span>
                    </div>
                    <div class="pl-10">
                      <div class="text-h6">
                        {{ personnel_temporarys.title_s
                        }}{{ personnel_temporarys.frist_name }}
                        {{ personnel_temporarys.last_name }}
                      </div>
                      <div class="caption grey--text mb-2">
                        จาก: {{ personnel_temporarys.college_name }}
                      </div>

                      <v-select
                        v-model="personnel_educations_b.id_branch"
                        :items="personnel_educations_b"
                        item-text="name_branch"
                        item-value="id_branch"
                        label="สาขาวิชาที่ลงตำแหน่งใหม่"
                        outlined
                        dense
                        background-color="white"
                        :rules="[v => !!v || 'กรุณาเลือกสาขา']"
                        prepend-inner-icon="mdi-book-open-variant"
                      ></v-select>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions class="grey lighten-5 pa-4">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="positiondialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="success"
              dark
              elevation="2"
              @click="updatepositionSubmit"
            >
              <v-icon left>mdi-check</v-icon> บันทึกข้อมูล
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
      elevation="4"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">{{ snackbar.icon }}</v-icon>
        {{ snackbar.text }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // ต้อง npm install xlsx
import { saveAs } from "file-saver"; // ต้อง npm install file-saver

export default {
  name: "HrvecProcessTransfer",
  components: { Movementmenu },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      search: "",
      select_item: [],
      selected: [],

      // Dialog Controls
      canceldialog: false,
      positiondialog: false,

      // Data Holders
      conditions_transfers: [], // Main List
      period_match: {},
      transference_personnels: {},
      transference_personnels_b: {},
      personnel_temporarys: {},
      personnel_educations: [],
      personnel_educations_b: [],
      conditons_transfer_successs: [],
      conditons_transfer_successs_b: [],

      // Forms
      updatepositions: {},
      updatepositions_b: {},

      // UI
      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      },
      headers: [
        { text: "เลือก", value: "select_item", sortable: false, width: "50px" },
        {
          text: "ข้อมูลฝั่ง A (ผู้ย้าย)",
          value: "person_a_details",
          sortable: false
        },
        {
          text: "",
          value: "status_process",
          sortable: false,
          align: "center",
          width: "50px"
        },
        {
          text: "ข้อมูลฝั่ง B (คู่สลับ)",
          value: "person_b_details",
          sortable: false,
          align: "right"
        },
        {
          text: "สถานะรายการ",
          value: "college_code_susss",
          align: "center",
          width: "120px"
        },
        {
          text: "จัดการ",
          value: "actions",
          sortable: false,
          align: "center",
          width: "100px"
        }
      ]
    };
  },
  computed: {
    // Statistics for the dashboard cards
    stats() {
      const total = this.conditions_transfers.length;
      const completed = this.conditions_transfers.filter(
        item => item.college_code_susss >= 1
      ).length;
      // Assume 'demand' status logic based on original code
      const demand = this.conditions_transfers.filter(
        item =>
          item.status_select_a === "demand" || item.status_select_b === "demand"
      ).length;
      const issue = total - completed; // Simple calculation for pending/issues

      return { total, completed, demand, issue };
    },
    period_label() {
      return this.period_match.period_times
        ? `${this.period_match.period_times}/${this.period_match.period_year}`
        : "N/A";
    }
  },
  async mounted() {
    await this.initializeData();
  },
  methods: {
    async initializeData() {
      await this.period_QueryAll();
      await this.Switch_personnelAll();
    },

    // --- API Calls ---
    async period_QueryAll() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable_process: "1",
          period_id: "301"
        });
        this.period_match = result.data;
      } catch (e) {
        console.error("Error fetching period:", e);
      }
    },

    async Switch_personnelAll() {
      this.loading = true;
      try {
        let result = await this.$http.post("process_transfer.php", {
          ApiKey: this.ApiKey,
          switchs_normal: "Ok",
          time_s: this.period_match.period_times,
          year_s: this.period_match.period_year
        });
        this.conditions_transfers = result.data;
      } catch (e) {
        this.showSnackbar("error", "เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        this.loading = false;
      }
    },

    async select_idPosition(id_ref) {
      this.loading = true;
      try {
        // 1. Get Person A Info
        let res_tran_a = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        });
        this.transference_personnels = res_tran_a.data;

        // 2. Get Person B Info (Basic)
        let res_person_b = await this.$http.post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position
        });
        this.personnel_temporarys = res_person_b.data;

        console.log(res_person_b.data)

        // 3. Get Education A
        let res_edu_a = await this.$http.post("personnel_education.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.id_card
        });
        this.personnel_educations = res_edu_a.data;

        // 4. Get Education B
        let res_edu_b = await this.$http.post("personnel_education.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position
        });
        this.personnel_educations_b = res_edu_b.data;

        // 5. Get Person B Transfer Info
        let res_tran_b = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position,
          time_s: this.transference_personnels.time_ss,
          year_s: this.transference_personnels.year_ss
        });
        this.transference_personnels_b = res_tran_b.data;

        this.positiondialog = true;
      } catch (e) {
        this.showSnackbar("error", "ดึงข้อมูลล้มเหลว");
      } finally {
        this.loading = false;
      }
    },

    async updatepositionSubmit() {
      if (!this.$refs.updatepositionform.validate()) return;

      this.loading = true;
      try {
        // Prepare Payload A
        const payloadA = {
          ApiKey: this.ApiKey,
          ctstime_s: this.transference_personnels.time_ss,
          ctsyear_s: this.transference_personnels.year_ss,
          ctsid_postion_old: this.transference_personnels.id_position,
          ctscollege_code_old: this.transference_personnels.college_code,
          ctsid_card: this.transference_personnels.id_card,
          ctsid_ref: this.transference_personnels.tid_ref,
          ctsname_position: "ครู",
          ctscollege_code: this.personnel_temporarys.college_code,
          ctsid_position: this.personnel_temporarys.id_position,
          ctsid_branch: this.transference_personnels.id_branch,
          ctsstatus_select: "sw_normal"
        };

        // Prepare Payload B
        const payloadB = {
          ApiKey: this.ApiKey,
          ctstime_s: this.transference_personnels_b.time_ss,
          ctsyear_s: this.transference_personnels_b.year_ss,
          ctsid_postion_old: this.personnel_temporarys.id_position,
          ctscollege_code_old: this.personnel_temporarys.college_code,
          ctsid_card: this.personnel_temporarys.id_card,
          ctsid_ref: this.transference_personnels_b.tid_ref,
          ctsname_position: "ครู",
          ctscollege_code: this.transference_personnels.college_code,
          ctsid_position: this.transference_personnels.id_position,
          ctsid_branch: this.personnel_educations_b.id_branch,
          ctsstatus_select: "sw_normal"
        };

        let resA = await this.$http.post(
          "conditons_transfer_success.insert.php",
          payloadA
        );
        let resB = await this.$http.post(
          "conditons_transfer_success.insert.php",
          payloadB
        );

        if (resA.data.status === true && resB.data.status === true) {
          this.showSnackbar("success", "บันทึกข้อมูลเรียบร้อยแล้ว");
          this.positiondialog = false;
          this.Switch_personnelAll();
        } else {
          this.showSnackbar(
            "warning",
            "การบันทึกข้อมูลมีปัญหา กรุณาลองใหม่อีกครั้ง"
          );
        }
      } catch (e) {
        this.showSnackbar("error", "Server Error: ไม่สามารถบันทึกได้");
      } finally {
        this.loading = false;
      }
    },

    async deletePosition(id_ref) {
      this.loading = true;
      try {
        // Fetch data needed for deletion context
        let res_con = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        });
        this.transference_personnels = res_con.data;

        let res_person = await this.$http.post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position
        });
        this.personnel_temporarys = res_person.data;

        // Fetch Success Records to delete
        let res_cts = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: id_ref
        });
        this.conditons_transfer_successs = res_cts.data;

        let res_cts_b = await this.$http.post(
          "conditons_transfer_success.php",
          {
            ApiKey: this.ApiKey,
            ctsid_card: this.transference_personnels.switch_position,
            ctstime_s: this.transference_personnels.time_ss,
            ctsyear_s: this.transference_personnels.year_ss
          }
        );
        this.conditons_transfer_successs_b = res_cts_b.data;

        this.canceldialog = true;
      } catch (e) {
        this.showSnackbar("error", "ไม่สามารถดึงข้อมูลเพื่อการลบได้");
      } finally {
        this.loading = false;
      }
    },

    async cancelSubmit() {
      this.loading = true;
      try {
        this.conditons_transfer_successs.ApiKey = this.ApiKey;
        this.conditons_transfer_successs_b.ApiKey = this.ApiKey;

        let res_del_a = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successs
        );
        let res_del_b = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successs_b
        );

        if (res_del_a.data.status === true && res_del_b.data.status === true) {
          this.showSnackbar("success", "ยกเลิกรายการเรียบร้อยแล้ว");
          this.canceldialog = false;
          this.Switch_personnelAll();
        } else {
          this.showSnackbar("error", "การยกเลิกไม่สมบูรณ์");
        }
      } catch (e) {
        this.showSnackbar("error", "Server Error ในการลบข้อมูล");
      } finally {
        this.loading = false;
      }
    },

    // --- Helpers ---
    showSnackbar(color, text) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.icon =
        color === "success" ? "mdi-check-circle" : "mdi-alert-circle";
      this.snackbar.show = true;
    },

    exportToExcel() {
      // 1. Filter Data for Export
      const exportData = this.conditions_transfers.map(item => ({
        "ID A": item.id_card_a,
        "ชื่อ-สกุล A": `${item.title_s_a}${item.frist_name_a} ${item.last_name_a}`,
        "วิทยาลัย A": item.college_name_a,
        "ID B": item.switch_position,
        "ชื่อ-สกุล B": `${item.title_s_b}${item.frist_name_b} ${item.last_name_b}`,
        "วิทยาลัย B": item.college_name_b,
        สถานะ: item.college_code_susss >= 1 ? "สำเร็จ" : "รออนุมัติ"
      }));

      // 2. Create Worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // 3. Create Workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Transfer_Data");

      // 4. Write File
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });

      saveAs(
        data,
        `Transfer_Normal_Switch_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    }
  }
};
</script>

<style scoped>
/* Custom Styles specific to this page */
.border-left {
  border-left: 4px solid #1976d2;
}
/* Table Row Hover Effect override */
::v-deep .v-data-table__wrapper tr:hover {
  background-color: #f5f5f5 !important;
}
</style>
